jQuery(document).ready(function(){

  $(function () {
    // Get the first `.js-drilldown-back a` from each non-third-level submenu
    const $drilldownBackAnchors = $(
      $('.menu .is-drilldown-submenu-parent .drilldown-submenu-cover-previous:not(.third-level)').map(function () {
        return $(this).find('.js-drilldown-back a').first()[0];
      }).get()
    );
  
    // Handle main submenu parent clicks
    $('.is-drilldown-submenu-parent > a').click(function () {
      const $parent = $(this).parent();
  
      // Activate corresponding submenu
      $('.is-active').removeClass('is-active');
      $(this).next('ul').addClass('is-active');
  
      // Manage overflow state: only one at a time
      $parent
        .addClass('overflow-hidden')
        .siblings('.is-drilldown-submenu-parent')
        .removeClass('overflow-hidden');

      // Add class to hide bottom nav elements from showing
      $('.mobile-nav__item--secondary').addClass('mobile-subnav-hidden');
    });
  
    // Remove overflow-hidden when a child submenu item is clicked
    $('.is-drilldown-submenu-parent-child a').click(function () {
      $(this).closest('.is-drilldown-submenu-parent').removeClass('overflow-hidden');
      $('.menu.drilldown').css('height', '100vh');
    });
  
    // Re-apply overflow-hidden when returning from a third-level back link
    $('.third-level .js-drilldown-back a').click(function () {
      $(this).closest('.is-drilldown-submenu-parent').addClass('overflow-hidden');
      $('.menu.drilldown').css('height', '');
    });
  
    // Activate third-level submenu when clicking into it
    $('.is-drilldown-submenu-parent-child > a').click(function () {
      $(this).next('ul.third-level').addClass('is-active');
    });
  
    // Go back up a level — remove active state from parent submenu
    $('.js-drilldown-back > a').click(function () {
      $(this).closest('.is-active').removeClass('is-active');
    });
  
    // On back link per tier, remove overflow-hidden from grandparent tier
    $drilldownBackAnchors.click(function () {
      $(this).closest('.is-drilldown-submenu-parent').removeClass('overflow-hidden');
      $('.mobile-nav__item--secondary').removeClass('mobile-subnav-hidden');
    });
  });

  //Back to top button logic
  var bttBtn = $('#BacktotopButton');

  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      bttBtn.addClass('show');
    } else {
      bttBtn.removeClass('show');
    }
  });

  bttBtn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '100');
  });

    
  if (window.location.href.indexOf('rest') >= 0) {
      $('html, body').scrollTop(0);    
  }

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

	function toggleScrollInit() {
	  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	  const isDevice = window.matchMedia('(max-width: 960px)').matches;
	  const $body = $('body');

	  if (currentScrollTop <= 10) {
	    $body.removeClass('scroll-init device-scroll-init');
	  } else if (isDevice) {
	    // Mobile only
	    if (currentScrollTop > lastScrollTop) {
	      // Scrolling down on mobile
	      $body.addClass('scroll-init');
	      $body.removeClass('device-scroll-init');
	    } else if (currentScrollTop < lastScrollTop) {
	      // Scrolling up on mobile
	      $body.addClass('scroll-init device-scroll-init');
	    }
	  } else {
	    // Desktop only
	    if (currentScrollTop < lastScrollTop) {
	      // Scrolling up on desktop
	      $body.addClass('scroll-init');
	      $body.removeClass('device-scroll-init');
	    } else if (currentScrollTop > lastScrollTop) {
	      // Scrolling down on desktop
	      $body.removeClass('scroll-init device-scroll-init');
	    }
	  }

	  lastScrollTop = Math.max(currentScrollTop, 0);
	}

	$(window).on('scroll resize', toggleScrollInit);
	
}, false );